module.exports = __webpack_public_path__ + "static/media/34DSS1.d7eaa95d.jpg";